import React from 'react';
import PropTypes from 'prop-types';

import DySlider from '../DySlider/DySlider';
import { StyledDiv } from './CartDrawerFooterAltStyles';

var _ref = React.createElement('div', { id: 'cart-drawer-double-billboard' });

var CartDrawerFooterAlt = function CartDrawerFooterAlt(props) {
  return React.createElement(
    StyledDiv,
    null,
    React.createElement(DySlider, {
      addVariantToCart: props.addVariantToCart,
      checkout: props.checkout,
      dySlug: 'cart-drawer'
    }),
    _ref
  );
};

CartDrawerFooterAlt.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired
};

export default CartDrawerFooterAlt;